/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_ActiveInputs */

const en_read_along_ai_active = /** @type {(inputs: Read_Along_Ai_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working on your document.`)
};

const es_read_along_ai_active = /** @type {(inputs: Read_Along_Ai_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesando tu documento.`)
};

/**
* | output |
* | --- |
* | "Working on your document." |
*
* @param {Read_Along_Ai_ActiveInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_active = /** @type {((inputs?: Read_Along_Ai_ActiveInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_ActiveInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_active(inputs)
	return en_read_along_ai_active(inputs)
});